export { productFlags, feePolicy } from '@hoodmorning/config/product-policy';

// Selected only by the explicit hoodmorning-testnet build condition. This is
// preparation, not a reviewed trading release or a deployed environment.
export const networkBuild = Object.freeze({
  schemaVersion: 1,
  chainId: 46630,
  identity: 'hoodmorning.robinhood46630.preparation.v1',
  testnetPreparation: true,
} as const);

export const databaseIdentity = Object.freeze({
  required: true,
  schemaIdentity: 'hoodmorning.robinhood46630.schema.2026-10-02.v1',
  sourceManifestSha256: '0ac9a833560870cdb99ee12b930c8ccdb97608b7873c73c7977cb9a2ed758ea8',
} as const);

export const robinhoodChain = Object.freeze({
  id: 46630,
  name: 'Robinhood Chain Testnet — TEST FUNDS ONLY',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: Object.freeze(['https://rpc.testnet.chain.robinhood.com'] as const),
  blockExplorerUrl: 'https://explorer.testnet.chain.robinhood.com',
} as const);

// Observed with six bounded read-only calls at one number/hash-rechecked 46630
// block on 2 October. The original metadata report, not raw runtime bytecode,
// is retained. These pins still need fresh verification in each consuming
// account path. Matching observations do not approve other contracts/providers.
export const accountPinObservation = Object.freeze({
  chainId: 46630,
  report: 'output/testnet46630-readonly-account-code-20261002.json',
  reportSha256: '915fecbc8f76abedfeb2f20b89e71d6610a8e35f52286de46ead9ed0887f6622',
  rawBytecodeRetained: false,
  tradingReleaseVerified: false,
} as const);

export const pinnedContracts = Object.freeze({
  accountProfile: Object.freeze({
    accountType: 'sma-b',
    accountId: 'alchemy.sma-bytecode.1.0.0',
    modularAccountRelease: 'v2.0.0',
    entryPointVersion: '0.7',
  } as const),
  entryPointV07: Object.freeze({
    address: '0x0000000071727De22E5E9d8BAf0edAc6f37da032',
    codeHash: '0x8db5ff695839d655407cc8490bb7a5d82337a86a6b39c3f0258aa6c3b582fc58',
  } as const),
  accountFactory: Object.freeze({
    address: '0x00000000000017c61b5bEe81050EC8eFc9c6fecd',
    codeHash: '0xd797dac2d304de879abba3ed87b60f9f141b2da869c3ce24c037feb5c5d60342',
  } as const),
  smaBImplementation: Object.freeze({
    address: '0x000000000000c5A9089039570Dd36455b5C07383',
    codeHash: '0x3612f3fa5ac5e89b87b284024977e6082441e30ff05f9f8497cd280131a27e16',
  } as const),
  // No testnet deployment has been verified. Never substitute a mainnet router
  // or omit this required pin from default full-product verification.
  universalRouterV211: Object.freeze({ address: null, codeHash: null }),
});
